import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShutterSpeedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"shutter_speed"}/>
}
